import { Reveal } from "./Reveal";
import { SERVICES } from "../lib/data";

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-20 md:py-32 border-t border-white/5 bg-[#080808] scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="max-w-3xl mb-12 md:mb-16">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5 md:mb-6">Services</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-black uppercase tracking-tight text-white text-3xl sm:text-4xl md:text-6xl leading-[0.95]">
            Craft cocktails, <span className="text-[#D4AF37]">delivered at scale.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-xl text-base md:text-lg text-white/60 font-light leading-relaxed">
            Every program is delivered with exceptional speed, consistency and presentation — from an
            intimate suite to a stadium concourse.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.title} delay={0.05 * (i % 3)}>
              <div
                data-testid={`service-card-${i}`}
                className="h-full bg-[#0a0a0a] border border-white/5 hover:border-[#D4AF37]/40 transition-colors duration-500 p-7 md:p-8 group"
              >
                <Icon className="w-7 h-7 text-[#D4AF37]" strokeWidth={1.4} />
                <h3 className="mt-6 font-display font-bold uppercase tracking-wide text-white text-lg md:text-xl leading-tight">{s.title}</h3>
                <p className="mt-3 text-sm md:text-[15px] text-white/55 font-light leading-relaxed">{s.copy}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
